import React from 'react'
import { withMantineProviderWrapper } from 'plugin-mantine-resources/shared/mantineProvider'
import { MetricsRegistry, MetricParams } from 'plugin-product-frac-ui/shared/registries/metrics-registry'
import MetricsCard from './widgets/MetricsCard'
import ChartMetricsCard from './widgets/charts/ChartMetricsCard'

let isFracWidgetsRegistered = false

const MetricsCardWithMantine = withMantineProviderWrapper(MetricsCard)
const ChartMetricsCardWithMantine = withMantineProviderWrapper(ChartMetricsCard)

function ChartMetricsKpi({ params }: { params: MetricParams }): React.ReactElement {
    const rootRef = React.useRef<HTMLDivElement>(null)

    React.useEffect(() => {
        const metricsCard = rootRef.current?.closest('.metrics-card') as HTMLElement | null

        if (!metricsCard) return undefined

        const previousPadding = metricsCard.style.padding
        const previousOverflow = metricsCard.style.overflow

        metricsCard.style.padding = '16px'
        metricsCard.style.overflow = 'visible'

        return () => {
            metricsCard.style.padding = previousPadding
            metricsCard.style.overflow = previousOverflow
        }
    }, [])

    return React.createElement('div', { ref: rootRef }, React.createElement(ChartMetricsCardWithMantine, { params }))
}

const AverageMetricsKpi = function AverageMetricsKpi({ params }: { params: MetricParams }): React.ReactElement {
    return React.createElement(MetricsCardWithMantine, { metricType: 'average', params })
}

const PercentageMetricsKpi = function PercentageMetricsKpi({ params }: { params: MetricParams }): React.ReactElement {
    return React.createElement(MetricsCardWithMantine, { metricType: 'percentage', params })
}

export function registerFracWidgets(): void {
    if (isFracWidgetsRegistered) {
        return
    }

    MetricsRegistry.register({ id: 'metrics-card-1', order: 1, component: ChartMetricsKpi })
    MetricsRegistry.register({ id: 'metrics-card-2', order: 2, component: AverageMetricsKpi })
    MetricsRegistry.register({ id: 'metrics-card-3', order: 3, component: PercentageMetricsKpi })

    isFracWidgetsRegistered = true
}
